import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Toast from '../components/Toast';
import Loader from '../components/Loader';
import Sweetalert from "sweetalert2";

const AdControlForm = () => {
  const navigate = useNavigate();
  const token = window.sessionStorage.getItem("usrtk");
  const [form, setForm] = useState({adIds: "", reductionPercent: "", ordersLimit: ""});
  const [loading, setLoading] = useState(false);
  const [infoLoading, setInfoLoading] = useState(true);
    const [markPaidOn, setMarkPaidOn] = useState(false);

  const inputChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  }

  useEffect(() => {
    if (!token) {
      Toast.fire({icon: "error", title: "You need to be logged in"})
      .then(() => navigate("/login"));
    } 

    setLoading(true);

    fetch(`${process.env.REACT_APP_SERVER_URL}/users/getadconfigdetails`, 
      {
        headers: {
            "authorization": `Bearer ${token}`
        }
      }
    )
    .then(r => r.json())
    .then(res => {
      setLoading(false);
      if (res.type === "error") {
        return Toast.fire({icon: "error", title: res.message}).then(() => navigate('/dashboard'));;
      }
      console.log(res)
      setForm(res);
    })
    .catch((err) => {
      setLoading(false);
      Toast.fire({icon: "error", title: "Server error"});
    })


          //Get user info
          fetch(`${process.env.REACT_APP_SERVER_URL}/users/info`, 
            {
              headers: {
                "authorization": `Bearer ${token}`
              }
            })
          .then(r => r.json())
          .then(res => {
            setInfoLoading(false);
            if (res.type === "error") {
              Toast.fire({icon: "error", title: res.message})
              .then(() => navigate('/login'));
            }
            setMarkPaidOn(res.autoPrice);
          })
          .catch((err) => {
            setInfoLoading(false);
            Toast.fire({icon: "error", title: "Server error"});
          })

  }, [])


    //Change auto mark status
    const changeMarkPaidStatus = () => {
      const token = window.sessionStorage.getItem("usrtk");

          setInfoLoading(true);
            fetch(`${process.env.REACT_APP_SERVER_URL}/users/updateautoprice`, 
              {
                method: "POST",
                body: JSON.stringify({autoPrice: !markPaidOn}),
                headers: {
                  "Content-Type": "application/json",
                  "authorization": `Bearer ${token}`
                }
              }
            )
            .then(r => r.json())
            .then(res => {
              setInfoLoading(false);
              if (res.type === "error") {
                return Toast.fire({icon: "error", title: res.message});
              }
              const newStatus = (!markPaidOn) ? "ON" : "OFF";
              setMarkPaidOn(!markPaidOn);
              Toast.fire({icon: "success", title: "You have successfully turned " + newStatus + " auto mark paid"});
            })
            .catch((err) => {
              console.log(err);
              setInfoLoading(false);
              Toast.fire({icon: "error", title: "Server error"});
            })
    }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/users/setadmonitoring`, 
      {
        method: "POST",
        body: JSON.stringify({...form, adIds: form.adIds.toString()}),
        headers: {
          "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        }
      }
    )
    .then(r => r.json())
    .then(res => {
      setLoading(false);
      if (res.type === "error") {
        return Toast.fire({icon: "error", title: res.message});
      }
      Toast.fire({icon: "success", title: "Ads Control details updated successfully!"})
      .then(() => navigate('/'));
    })
    .catch((err) => {
      setLoading(false);
      Toast.fire({icon: "error", title: "Server error"});
    })

  };

  return (
    <div className="container">

      {
        infoLoading && <Loader content={""} />
      }
      <div className="toggle-section">
        <label className="switch">
          <input
            type="checkbox"
            checked={markPaidOn}
            onChange={changeMarkPaidStatus}
          />
          <span className="slider"></span>
        </label>
        <span className="switch-label">Auto pricing status: {(markPaidOn) ? "ON" : "OFF"}</span>
      </div>

      <h1>Set Your Ad Control Details</h1>
      <form onSubmit={handleSubmit} className='login'>

        <label>Ads ID (Separate each with a comma):</label>
        <textarea cols={15} name="adIds" placeholder='eg: 122525255273737, 272724574857346, 183734759483737' onChange={inputChange} value={form.adIds} id=""></textarea>

        <label>Orders Count Limit:</label>
        <input
          type="Number"
          value={form.ordersLimit}
          name='ordersLimit'
          onChange={inputChange}
        />

        <label>Order Price Reduction Percent:</label>
        <input
          type="Number"
          step={0.1}
          value={form.reductionPercent}
          name='reductionPercent'
          onChange={inputChange}
          max={5}
        />



        <button type="submit">{loading ? "Updating info..." : "Set Ad Control"}</button>
      </form>

      <p style={{textAlign: "center"}}>
        <Link to={"/"}>&lt;&lt;Back to Home</Link>
      </p>
    </div>
  );
};

export default AdControlForm;
